export default __webpack_public_path__ + "static/media/frame_51_delay-0.05s.fea65320.gif";